import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout, ConfigProvider, message } from 'antd';
import skSK from 'antd/locale/sk_SK';
import CustomerPortal from './components/CustomerPortal';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CreateCustomer from './components/CreateCustomer'

const { Content } = Layout;

const Root = () => {
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (window.$app) {
      window.$app.setMessageApi(messageApi);
    }
  }, [messageApi]);

  return (
    <>
      {contextHolder}
      <ConfigProvider locale={skSK}>
        <Layout className="app-layout">
          <Header />
          <Layout className="main-content-wrapper">
            <Content className="app-content">
              <Routes>
                <Route path="/" element={<CustomerPortal />} />
                <Route path="/registrace" element={<CreateCustomer />} />
              </Routes>
            </Content>
          </Layout>
          <Footer />
        </Layout>
      </ConfigProvider>
    </>
  );
};

export default Root;
